import { render, staticRenderFns } from "./CmgLoyaltyBannerHomepage.vue?vue&type=template&id=163f3781&scoped=true&lang=pug"
import script from "./cmg-loyalty-banner-homepage.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-banner-homepage.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyBannerHomepage.vue?vue&type=style&index=0&id=163f3781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f3781",
  null
  
)

export default component.exports